var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "cs-total", style: { height: "100%" } },
    [
      _c(
        "div",
        { staticClass: "title-box" },
        [
          _c("div", [
            _vm._v(
              _vm._s(_vm.$ct("cashier-title")) + " " + _vm._s(_vm.activeCashier)
            ),
          ]),
          _c("w-spacer"),
          _c("div", { staticClass: "box" }, [
            _c(
              "button",
              {
                class: {
                  active: _vm.activeCashier == 1,
                  inUse: _vm.storage[0]?.Rows.length,
                },
                on: {
                  click: function ($event) {
                    ;(_vm.activeCashier = 1),
                      _vm.fetchCashierFromStorage(),
                      $event.target.blur()
                  },
                },
              },
              [_vm._v("1")]
            ),
            _c(
              "button",
              {
                class: {
                  active: _vm.activeCashier == 2,
                  inUse: _vm.storage[1]?.Rows.length,
                },
                on: {
                  click: function ($event) {
                    ;(_vm.activeCashier = 2),
                      _vm.fetchCashierFromStorage(),
                      $event.target.blur()
                  },
                },
              },
              [_vm._v("2")]
            ),
            _c(
              "button",
              {
                class: {
                  active: _vm.activeCashier == 3,
                  inUse: _vm.storage[2]?.Rows.length,
                },
                on: {
                  click: function ($event) {
                    ;(_vm.activeCashier = 3),
                      _vm.fetchCashierFromStorage(),
                      $event.target.blur()
                  },
                },
              },
              [_vm._v("3")]
            ),
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    ;(_vm.activeCashier = 1),
                      _vm.initCashierStorage(),
                      _vm.fetchCashierFromStorage(),
                      _vm.scrollTop(),
                      $event.target.blur()
                  },
                },
              },
              [_vm._v("x")]
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "customer" },
        [
          _c(
            "div",
            {
              staticClass: "cs-button contact",
              on: {
                click: function ($event) {
                  return _vm.openSettings()
                },
              },
            },
            [
              _c("w-fa", {
                style: { margin: "2px 8px 0 0" },
                attrs: { icon: "user", "ico-lib": "fal" },
              }),
              _vm._v(
                " " + _vm._s(_vm.state.sale.Contact?.getDisplayName()) + " "
              ),
            ],
            1
          ),
          _c("w-spacer"),
          _c(
            "div",
            {
              staticClass: "cs-button gray",
              on: {
                click: function ($event) {
                  return _vm.openSettings()
                },
              },
            },
            [_vm._v(_vm._s(_vm.state.sale.Type.getDisplayedName("nl-be")))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "total-items", style: { height: _vm.bodyHeight } },
        [
          _c(
            "w-row",
            { staticClass: "sale-row-header" },
            [
              _c("w-col", { attrs: { sm: "12", md: "2" } }, [
                _vm._v(_vm._s(_vm.$ct("header.amount"))),
              ]),
              _c("w-col", { attrs: { sm: "12", md: "7" } }, [
                _vm._v(_vm._s(_vm.$ct("header.description"))),
              ]),
              _c(
                "w-col",
                { style: { textAlign: "right" }, attrs: { sm: "12", md: "3" } },
                [_vm._v(_vm._s(_vm.$ct("header.price")))]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "body" },
            [
              _c(
                "w-scroll-view",
                {
                  ref: "scrollBox",
                  staticClass: "scroll-box",
                  attrs: { tag: "div" },
                },
                _vm._l(_vm.state.sale.Rows, function (row, index) {
                  return _c(
                    "w-row",
                    {
                      key: index,
                      staticClass: "sale-row",
                      class: {
                        selected: _vm.isSelected(row),
                        first: index === 0,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.select(row)
                        },
                      },
                    },
                    [
                      _c("w-col", { attrs: { sm: "12", md: "2" } }, [
                        _vm._v(_vm._s(row.Amount)),
                      ]),
                      _c("w-col", { attrs: { sm: "12", md: "7" } }, [
                        _vm._v(" " + _vm._s(row.ProductDescription) + " "),
                        row.SizeTableEntry
                          ? _c("div", { staticClass: "subtext" }, [
                              _vm._v(
                                _vm._s(_vm.$ct("size")) +
                                  ": " +
                                  _vm._s(row.SizeTableEntry.Name)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "w-col",
                        {
                          class: { discount: row.Discount != 0 },
                          style: { textAlign: "right" },
                          attrs: { sm: "12", md: "3" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.printHumanFloat(
                                row.getTotalWithVatWithTaxes()
                              )
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pad-wrap" },
        [
          _c("app-cashier-key-pad", {
            attrs: { state: _vm.state },
            on: {
              "add-diverse": function ($event) {
                return _vm.openDiverseModal($event)
              },
              store: _vm.saveStorage,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "total-footer" },
        [
          _c("div", { staticClass: "total-box" }, [
            _c("div", { staticClass: "total-title" }, [
              _vm._v(_vm._s(_vm.$ct("title.total"))),
            ]),
            _c("div", { staticClass: "total" }, [
              _vm._v(
                "EUR " + _vm._s(_vm.printHumanFloat(_vm.state.sale.TotalToPay))
              ),
            ]),
          ]),
          _c("w-spacer"),
          _c(
            "div",
            {
              staticClass: "cs-button green",
              on: {
                click: function ($event) {
                  return _vm.send()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("pay")))]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.openEditSaleSettings,
            callback: function ($$v) {
              _vm.openEditSaleSettings = $$v
            },
            expression: "openEditSaleSettings",
          },
        },
        [
          _c("app-cashier-sale-settings", {
            attrs: { state: _vm.state },
            on: {
              close: function ($event) {
                _vm.openEditSaleSettings = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.openAddDiverse,
            callback: function ($$v) {
              _vm.openAddDiverse = $$v
            },
            expression: "openAddDiverse",
          },
        },
        [
          _c("app-cashier-add-diverse", {
            attrs: { state: _vm.state, amount: _vm.diverseAmount },
            on: {
              close: function ($event) {
                _vm.openAddDiverse = false
              },
            },
          }),
        ],
        1
      ),
      _vm.state.ticketRefundModalOpen
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.state.ticketRefundModalOpen,
                callback: function ($$v) {
                  _vm.$set(_vm.state, "ticketRefundModalOpen", $$v)
                },
                expression: "state.ticketRefundModalOpen",
              },
            },
            [
              _c("app-ticket-refund-modal", {
                attrs: { state: _vm.state },
                on: {
                  update: function ($event) {
                    return _vm.complete()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }